import { useContext } from 'react';
import './style.scss';
import { FormDataContext } from '../FormDataProvider';

function MemberFeeStep() {

  const { handleStepChoise, formData, changeCurrentStep, stepList } = useContext(FormDataContext);

  return (
    <div className="membership-fee-step">
      <h2>Medlemsavgift</h2>
      <p className="desc">Ange nedan hur du vill betala medlemsavgiften.</p>

        {formData['project_lecture_education'] == true && <b style={{display: 'block', textAlign: 'center', marginBottom: '30px'}}>Eftersom du ansöker i samband med en föreläsning får du första året gratis. Välj nedan hur du önskar betala medlemsavgiften efter ditt avgiftsfria år.</b>}

        <form>
            <div className="step-bubble" name="payment_method" value="auto" onClick={(e) => handleStepChoise(e)}>
                <h3>Autogiro</h3>
                <p>Ordinarie 166 kr/månad<br />
                  Student 25 kr/månad<br />
                  Pensionär 55 kr/månad</p>
            </div>
            <div className="step-bubble" name="payment_method" value="invoice" onClick={(e) => handleStepChoise(e)}>
                <h3>Årsfaktura</h3>
                <p>Ordinarie avgift 1992 kr/år<br />
                Studentavgift 300 kr/år<br />
                Pensionär 660 kr/år</p>
            </div>
        </form>
    </div>
  );
}

export default MemberFeeStep;
